// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchInput_searchInput__RA0uu","wrap_input":"SearchInput_wrap_input__YnB1Y","crossIcon":"SearchInput_crossIcon__7Cqxm"};